import { Bot, User } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";

export type MessageEntry = {
  id: string;
  sessionId: string;
  seq: number;
  role: "user" | "assistant";
  kind: "response" | "tool" | "reasoning" | "plan" | "commit";
  content: string;
  createdAt: string;
};

export function MessageBubble({ msg }: { msg: MessageEntry }) {
  const isUser = msg.role === "user";
  return (
    <div className={`flex gap-3 ${isUser ? "flex-row-reverse" : ""}`}>
      <div
        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border ${
          isUser
            ? "border-primary bg-primary text-primary-foreground"
            : "border-border bg-muted"
        }`}
      >
        {isUser ? <User className="h-3.5 w-3.5" /> : <Bot className="h-3.5 w-3.5" />}
      </div>
      <div
        className={`max-w-[70%] space-y-1 ${isUser ? "items-end" : "items-start"} flex flex-col`}
      >
        {msg.kind !== "response" && (
          <Badge variant="outline" className="text-xs">
            {msg.kind}
          </Badge>
        )}
        <div
          className={`rounded-lg px-3 py-2 text-sm ${
            isUser ? "bg-primary text-primary-foreground" : "bg-muted text-foreground"
          } whitespace-pre-wrap`}
        >
          {msg.content}
        </div>
      </div>
    </div>
  );
}

export function ChatTranscript({ messages }: { messages: MessageEntry[] }) {
  return (
    <ScrollArea className="max-h-80">
      <div className="space-y-4 p-1">
        {messages.map((m) => (
          <MessageBubble key={m.id} msg={m} />
        ))}
      </div>
    </ScrollArea>
  );
}
